var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadFolder = function SvgDownloadFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3h9.028l2.5 3H22.9v15.4H1V3Zm1.4 1.4V20h19.1V7.4h-9.628l-2.5-3H2.4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12.254 15.702 1.663-1.565.783.738-3 2.825-3-2.825.784-.738 1.662 1.565V10.7h1.108v5.002Z",
    fill: "currentColor"
  })));
};
export { SvgDownloadFolder as ReactComponent };
export default __webpack_public_path__ + "f2817345d0518a4140752c355d650230.svg";